module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nif(environment.style == 'mobile'){\nvar img  = (model.imgMobile  ? model.imgMobile  : model.img);\nvar _img = (model._imgMobile ? model._imgMobile : model._img);\nvar title = (model.titleMobile != \"\" ? model.titleMobile : model.title);\nvar text  = (model.textMobile != \"\"  ? model.textMobile  : model.text);\n%>\n<%- include('../../../mobile/1it-1tbb-base/1it-1tbb-base', { model: { title: title, text: text, buttonText: model.buttonText, buttonColor: model.buttonColor, buttonAction: model.buttonAction, img: img, _img: _img } }); %>\n<%\n} else {\nvar p1 = (helpers.detectRenderedImage(model.img, model._img) || {}).rendered || {};\n%>\n<div class=\"texts\">\n<h3><%- model.title %></h3>\n<%- model.text %>\n</div>\n<%\nif(p1.url) {\n%>\n<div class=\"images\">\n<%\nif (environment.device && environment.device.type==\"bot\") { %>\n<img src=\"<%= p1.url %>\" alt=\"<%= p1.alt %>\" title=\"<%= p1.title %>\">\n<%              } else { %>\n<div class=\"polaroid p1\" style=\"background-image:url(<%= p1.url %>)\"></div>\n<%              } %>\n</div>\n<%\n}\n}\n%>\n</div>"
  , __filename = "components/templates/polaroid/1tl-1ir-b/1tl-1ir-b.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
if(environment.style == 'mobile'){
var img  = (model.imgMobile  ? model.imgMobile  : model.img);
var _img = (model._imgMobile ? model._imgMobile : model._img);
var title = (model.titleMobile != "" ? model.titleMobile : model.title);
var text  = (model.textMobile != ""  ? model.textMobile  : model.text);

    ; __line = 8
    ; __append("\n")
    ; __line = 9
    ; __append( include('../../../mobile/1it-1tbb-base/1it-1tbb-base', { model: { title: title, text: text, buttonText: model.buttonText, buttonColor: model.buttonColor, buttonAction: model.buttonAction, img: img, _img: _img } }) )
    ; __append("\n")
    ; __line = 10
    ; 
} else {
var p1 = (helpers.detectRenderedImage(model.img, model._img) || {}).rendered || {};

    ; __line = 13
    ; __append("\n<div class=\"texts\">\n<h3>")
    ; __line = 15
    ; __append( model.title )
    ; __append("</h3>\n")
    ; __line = 16
    ; __append( model.text )
    ; __append("\n</div>\n")
    ; __line = 18
    ; 
if(p1.url) {

    ; __line = 20
    ; __append("\n<div class=\"images\">\n")
    ; __line = 22
    ; 
if (environment.device && environment.device.type=="bot") { 
    ; __line = 23
    ; __append("\n<img src=\"")
    ; __line = 24
    ; __append(escapeFn( p1.url ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( p1.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( p1.title ))
    ; __append("\">\n")
    ; __line = 25
    ;               } else { 
    ; __append("\n<div class=\"polaroid p1\" style=\"background-image:url(")
    ; __line = 26
    ; __append(escapeFn( p1.url ))
    ; __append(")\"></div>\n")
    ; __line = 27
    ;               } 
    ; __append("\n</div>\n")
    ; __line = 29
    ; 
}
}

    ; __line = 32
    ; __append("\n</div>")
    ; __line = 33
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/polaroid/1tl-1ir-b/1tl-1ir-b.ejs

}